import styled, { createGlobalStyle } from 'styled-components';
import { ThemeFitToScreenCard } from '../SurveysStyle';
import { ThemeCard } from '../../Styles/Theme';
import { Col, Space } from 'antd';

/* Global styles for Popconfirm buttons - rendered in portal outside component tree */
export const PopconfirmGlobalStyles = createGlobalStyle`
  .ant-popconfirm {
    .ant-popconfirm-buttons {
      .ant-btn {
        border-radius: 6px !important;
        font-weight: 500 !important;
        transition: all 0.2s ease !important;
      }

      /* Cancel button (No) */
      .ant-btn-default {
        border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
        color: ${({ theme }) => theme.settings.primary} !important;
        background: ${({ theme }) => theme.settings.whiteColor} !important;

        &:hover {
          background: ${({ theme }) => theme.settings.cta_hover} !important;
          border-color: ${({ theme }) => theme.settings.mainColor} !important;
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
      }

      /* Confirm button (Yes) */
      .ant-btn-primary {
        background: ${({ theme }) => theme.settings.cta_hover} !important;
        border-color: ${({ theme }) => theme.settings.mainColor} !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;

        &:hover {
          background: ${({ theme }) => theme.settings.whiteColor} !important;
          border-color: ${({ theme }) => theme.settings.mainColor} !important;
          color: ${({ theme }) => theme.settings.primary} !important;
        }
      }
    }

    .ant-popconfirm-title {
      color: ${({ theme }) => theme.settings.primary} !important;
      font-weight: 600 !important;
    }

    .ant-popconfirm-description {
      color: ${({ theme }) => theme.settings.textColor} !important;
    }
  }
`;

export const PopoverGlobalStyles = createGlobalStyle`
  .ant-popover-inner {
    .ant-btn-default {
      color: #2E45DA;
      border-color: #d0d5dd;
      &:hover {
        color: #2E45DA !important;
        border-color: #2E45DA !important;
        background: rgba(46, 69, 218, 0.05) !important;
      }
    }
    .ant-btn-primary {
      background: #2E45DA !important;
      border-color: #2E45DA !important;
      &:hover {
        background: #2d1f4e !important;
        border-color: #2d1f4e !important;
      }
    }
    .ant-input:hover {
      border-color: #2E45DA !important;
    }
    .ant-input:focus,
    .ant-input-focused {
      border-color: #2E45DA !important;
      box-shadow: 0 0 0 2px rgba(46, 69, 218, 0.1) !important;
    }
  }
`;

export const RightPreviewCard = styled(ThemeFitToScreenCard)`
  border-radius: 16px !important;
  border: none;
  background: ${({ theme }) => theme.settings.whiteColor};
  height: calc(100vh - 90px);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media only screen and (max-width: 991.99px) {
    height: 100% !important;
  }

  .ant-card-head {
    border-bottom: 1px solid #edeef3;
    min-height: 64px;
    height: 64px;
    padding: 0 28px;
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.settings.whiteColor};
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    .ant-card-head-title {
      font-size: 14px;
      font-weight: 600;
      color: ${({ theme }) => theme.settings.primary};
      font-family: ${({ theme }) => theme.fonts.inter};
    }
  }

  .ant-card-body {
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  /* Proper padding for skeleton loading state */
  &.ant-card-loading .ant-card-body {
    padding: 24px;
  }
`;

export const ResponsiveChatColumn = styled(Col)`
  .responsive-chat-shell {
    display: contents;
  }

  .responsive-chat-close {
    display: none;
  }

  @media only screen and (max-width: 991.99px) {
    && {
      position: fixed;
      inset: 0;
      z-index: 1200;
      width: 100% !important;
      max-width: none !important;
      flex: none !important;
      padding: 0 !important;
      background: rgba(15, 23, 42, 0.22);
      -webkit-backdrop-filter: blur(2px);
      backdrop-filter: blur(2px);
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition:
        opacity 0.2s ease,
        visibility 0s linear 0.24s;
    }

    &&.is-open {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transition-delay: 0s;
    }

    .responsive-chat-shell {
      display: block;
      position: absolute;
      right: 16px;
      bottom: 16px;
      width: min(420px, calc(100vw - 32px));
      height: min(680px, calc(100vh - 32px));
      height: min(680px, calc(100dvh - 32px));
      border-radius: 16px;
      overflow: hidden;
      background: ${({ theme }) => theme.settings.whiteColor};
      box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24);
      opacity: 0;
      transform: translateY(24px) scale(0.97);
      transform-origin: bottom right;
      transition:
        opacity 0.22s ease,
        transform 0.22s ease;
    }

    &.is-open .responsive-chat-shell {
      opacity: 1;
      transform: translateY(0) scale(1);
    }

    .responsive-chat-shell > div {
      height: 100%;
    }

    .responsive-chat-shell .chatWrapper {
      height: 100% !important;
      border: 1px solid ${({ theme }) => theme.settings.borderColor} !important;
      border-radius: 16px !important;
      box-shadow: none !important;
    }

    .responsive-chat-shell .chatWrapper .ant-card-head {
      height: 56px;
      min-height: 56px;
      padding: 0 56px 0 20px;
    }

    .responsive-chat-shell .chatWrapper .ant-card-head-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .responsive-chat-shell .chatWrapper .ant-card-body {
      height: calc(100% - 56px);
    }

    .responsive-chat-shell .chatWrapper .scrollable {
      padding: 20px 20px 12px;
    }

    .responsive-chat-shell .survey-chat-composer-footer {
      padding: 14px 16px calc(16px + env(safe-area-inset-bottom, 0px));
    }

    .responsive-chat-close {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 3;
      width: 32px;
      height: 32px;
      padding: 0;
      border: 1px solid ${({ theme }) => theme.settings.borderColor};
      border-radius: 8px;
      background: ${({ theme }) => theme.settings.whiteColor};
      color: ${({ theme }) => theme.settings.primary};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.18s ease;

      &:hover,
      &:focus-visible {
        border-color: ${({ theme }) => theme.settings.mainColor};
        color: ${({ theme }) => theme.settings.mainColor};
        outline: none;
      }
    }
  }

  @media only screen and (max-width: 575.99px) {
    .responsive-chat-shell {
      inset: 12px;
      width: auto;
      height: auto;
      transform-origin: bottom center;
    }

    .responsive-chat-shell .chatWrapper .scrollable {
      padding: 16px 14px 10px;
    }
  }
`;

export const ResponsiveChatLauncher = styled.button`
  display: none;

  @media only screen and (max-width: 991.99px) {
    position: fixed;
    top: auto;
    right: 0;
    bottom: 20%;
    z-index: 1100;
    width: 48px;
    height: 44px;
    min-height: 44px;
    padding: 0;
    border: 0;
    border-radius: 24px 0 0 24px;
    background: ${({ theme }) => theme.settings.cta_hover};
    color: ${({ theme }) => theme.settings.whiteColor} !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: -4px 4px 14px rgba(46, 69, 218, 0.3);
    opacity: ${({ $open }) => ($open ? 0 : 1)};
    visibility: ${({ $open }) => ($open ? 'hidden' : 'visible')};
    pointer-events: ${({ $open }) => ($open ? 'none' : 'auto')};
    transform: ${({ $open }) => ($open ? 'translateX(10px) scale(0.96)' : 'translateX(0) scale(1)')};
    transition:
      opacity 0.18s ease,
      transform 0.18s ease,
      filter 0.18s ease,
      visibility 0s linear ${({ $open }) => ($open ? '0s' : '0.18s')};

    &:hover,
    &:focus-visible {
      color: ${({ theme }) => theme.settings.whiteColor};
      filter: brightness(1.08);
      transform: translateX(-2px) scale(1.02);
      outline: none;
    }

    .anticon {
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
    }

    .anticon svg {
      display: block;
      width: 17px;
      height: 17px;
      font-size: 17px;
      color: ${({ theme }) => theme.settings.whiteColor} !important;
      fill: currentColor;
    }

    .anticon svg path {
      fill: currentColor !important;
    }

    .responsive-chat-launcher-label {
      display: none;
    }
  }
`;

export const RightCardBody = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export const RightScrollArea = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  padding: 32px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: ${({ theme }) => theme.settings.whiteColor};
  overflow-y: scroll !important;
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.settings.secondary};
    border-radius: 1px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  @media only screen and (max-width: 991.99px) {
    padding: 5px;
    /* min-height: 100%;
    height: 100% !important;
    min-height: 100% !important; */
  }
`;

export const TargetAudienceSection = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
`;

export const TargetAudienceHeader = styled.div`
  width: 100%;
  border: none;
  outline: none;
  background: #f5f4f7;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ $open }) =>
    $open ? '1px solid ${({ theme }) => theme.settings.borderColor}' : 'none'};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: ${({ $open }) => ($open ? '0' : '10px')};
  border-bottom-right-radius: ${({ $open }) => ($open ? '0' : '10px')};
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background: ${({ theme }) => theme.settings.bodyBg};
    transition: all 0.2s ease;
  }
`;

export const TargetAudienceHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TargetAudienceTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const TargetAudienceDescription = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.settings.textColor};
`;

export const TargetAudienceToggle = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) => theme.settings.mainColor};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    opacity: 0.9;
  }

  svg {
    font-size: 12px;
    color: #fff;
    transform: rotate(${({ $open }) => ($open ? 180 : 0)}deg);
    transition: transform 0.2s ease;
  }
`;

export const TargetAudienceBody = styled.div`
  padding: 20px 22px;
`;

export const TargetAudienceCard = styled(ThemeCard)`
  border-radius: 16px;
  border: none;
  background: transparent;
  box-shadow: none;

  .ant-card-body {
    padding: 0;
  }

  .fieldLabel {
    font-size: 12px;
    font-weight: 500;
    color: #485066;
    margin: 0 0 8px 0;
    padding: 0;
    display: block;
    font-family: ${({ theme }) => theme.fonts.inter};
    line-height: 1.4;
  }

  .audienceSelect,
  .audienceNumber {
    margin: 0 !important;
  }

  .audienceSelect .ant-select-selector,
  .audienceNumber {
    min-height: 48px;
    border-radius: 10px !important;
    border: 1px solid rgba(10, 27, 57, 0.1) !important;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    box-shadow: none;
  }

  .audienceNumber {
    width: 100%;
    padding: 0;

    .ant-input-number-input-wrap {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .ant-input-number-input {
      background: transparent !important;
      font-weight: 400;
      color: ${({ theme }) => theme.settings.primary};
      font-size: 14px;
      font-family: ${({ theme }) => theme.fonts.inter};
      padding: 0 16px;
      height: 46px;
      text-align: left;
    }

    .ant-input-number-handler-wrap {
      display: none;
    }
  }

  .ant-select-selection-item {
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.inter};
  }

  .ant-select-selector {
    padding: 0 16px !important;
    display: flex;
    align-items: center;
  }

  .ant-select-arrow {
    right: 16px !important;
    top: 50% !important;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.settings.primary};
    margin-top: 0 !important;
  }

  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }

  .ant-select-single .ant-select-selector {
    height: 48px !important;
    display: flex;
    align-items: center;
  }

  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
    color: rgba(10, 27, 57, 0.4) !important;
    font-size: 14px !important;
    font-family: ${({ theme }) => theme.fonts.inter};
    line-height: 1 !important;
    padding: 0 !important;
    margin: 0 !important;
    inset-inline-start: 16px !important;
    inset-inline-end: 16px !important;
  }

  .ant-select-single .ant-select-selection-placeholder {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    left: 16px !important;
    right: 16px !important;
    padding: 0 !important;
  }

  .ant-select-multiple .ant-select-selection-placeholder {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    left: 12px !important;
    right: 12px !important;
    line-height: 1 !important;
    padding: 0 !important;
  }

  /* Tag/Chip styling for multiple select and tags mode */
  .ant-select-multiple .ant-select-selection-item {
    background: rgba(36, 58, 184, 0.1);
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
    margin: 4px 4px 4px 0;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    height: auto;
    line-height: 22px;
  }

  .ant-select-multiple .ant-select-selection-item-remove {
    color: ${({ theme }) => theme.settings.primary};
    font-size: 12px;
  }

  .ant-select-multiple .ant-select-selector {
    padding: 4px 12px !important;
    min-height: 48px;
    height: 48px;
    display: flex !important;
    align-items: center !important;
    align-content: center !important;
  }

  .ant-select-multiple .ant-select-selection-overflow {
    gap: 4px;
    flex-wrap: wrap;
  }

  /* ThemeInput styling for Topic field */
  .audienceInput {
    min-height: 48px;
    height: 48px;
    border-radius: 10px !important;
    border: 1px solid rgba(10, 27, 57, 0.1) !important;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    padding: 0 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.inter};
    margin: 0 !important;

    &::placeholder {
      color: rgba(10, 27, 57, 0.4);
    }

    &:focus {
      border-color: ${({ theme }) => theme.settings.primary} !important;
      box-shadow: none !important;
    }
  }
`;

export const AudienceGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 0;
`;

export const AudienceField = styled.div`
  display: flex;
  flex-direction: column;

  /* Reset any default margins from Ant Design components and their wrappers */
  > *:not(.fieldLabel) {
    margin: 0 !important;
  }

  .ant-select,
  .ant-input,
  .ant-input-number,
  .ant-input-number-affix-wrapper,
  .ant-radio-group,
  .ant-form-item,
  input {
    margin: 0 !important;
  }
`;

export const AgeInputGroup = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  border: 1px solid rgba(10, 27, 57, 0.1);
  border-radius: 10px;
  overflow: hidden;
  background: ${({ theme }) => theme.settings.whiteColor};
  height: 48px;
  align-items: center;
  margin: 0;
`;

export const AgeLabel = styled.div`
  background: #eae7ee;
  border-right: 1px solid rgba(10, 27, 57, 0.1);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const AgeInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  width: 100%;
  height: 100%;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: rgba(10, 27, 57, 0.3);
  }
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex-shrink: 0;
`;

export const NoQuestionsState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const NoQuestionsTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const QuestionCardHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #f5f4f7;
  border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

export const QuestionCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const QuestionBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 32px;
  padding: 0 14px;
  border-radius: 6px;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid rgba(10, 27, 57, 0.1);
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.mainColor};
`;

export const QuestionHeaderActions = styled(Space)`
  gap: 8px !important;

  /* Make all buttons same size and style - override ThemeFilterBtn defaults */
  .ant-btn,
  button {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    padding: 0 !important;
    border-radius: 6px !important;
    border: 1px solid rgba(10, 27, 57, 0.1) !important;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${({ theme }) => theme.settings.primary} !important;

    /* Override ThemeFilterBtn icon styles */
    svg,
    img,
    .anticon,
    .anticon svg,
    span.anticon,
    span.anticon svg {
      font-size: 14px !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      filter: none !important;
      transition:
        color 0.2s ease,
        filter 0.2s ease;
    }

    /* Override ThemeFilterBtn hover - keep icon purple not white */
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      border-color: ${({ theme }) => theme.settings.primary} !important;
      background: rgba(36, 58, 184, 0.05) !important;
      color: ${({ theme }) => theme.settings.primary} !important;

      svg,
      img,
      .anticon,
      .anticon svg,
      span.anticon,
      span.anticon svg {
        color: ${({ theme }) => theme.settings.primary} !important;
        filter: none !important;
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  /* Specifically override ThemeFilterBtn.btnBorder hover styles */
  .ant-btn.btnBorder,
  button.btnBorder {
    &:hover:not(:disabled) {
      background: rgba(36, 58, 184, 0.05) !important;

      svg,
      img,
      .anticon,
      span.anticon {
        color: ${({ theme }) => theme.settings.primary} !important;
        filter: none !important;
      }
    }
  }
`;

const { Compact } = Space;

export const FullWidthCompact = styled(Compact)`
  width: 100%;
`;

export const QuestionEditWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;

  input {
    flex: 1;
    height: 36px;
    border: 1px solid rgba(10, 27, 57, 0.1);
    border-radius: 8px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    font-family: ${({ theme }) => theme.fonts.inter};
    background: ${({ theme }) => theme.settings.whiteColor};

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.settings.primary};
    }
  }

  button {
    height: 32px;
    padding: 0 14px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.inter};
    cursor: pointer;
    transition: all 0.2s ease;

    &.save {
      background: ${({ theme }) => theme.settings.cta_hover};
      border: 1px solid ${({ theme }) => theme.settings.mainColor};
      color: ${({ theme }) => theme.settings.whiteColor};

      &:hover {
        background: ${({ theme }) => theme.settings.whiteColor};
        border-color: ${({ theme }) => theme.settings.mainColor};
        color: ${({ theme }) => theme.settings.primary};
      }
    }

    &.cancel {
      background: transparent;
      border: 1px solid rgba(10, 27, 57, 0.1);
      color: ${({ theme }) => theme.settings.primary};

      &:hover {
        border-color: rgba(10, 27, 57, 0.2);
      }
    }
  }
`;

export const SurveyTitleSection = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid #edeef3;
  border-radius: 10px;
  padding: 26px 22px;
`;

export const SurveyTitleText = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0 0 16px 0;
`;

export const SurveyTypeButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const SurveyTypeButton = styled.button`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid rgba(10, 27, 57, 0.1);
  border-radius: 6px;
  padding: 9px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  cursor: pointer;
  height: 32px;
  transition: all 0.2s ease;

  img,
  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    border-color: rgba(10, 27, 57, 0.2);
  }
`;

export const AddQuestionCard = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 24px 22px;
`;

export const AddQuestionTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0 0 16px 0;
`;

export const AddQuestionInputWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;

  input {
    flex: 1;
    height: 48px;
    border: 1px solid rgba(10, 27, 57, 0.1);
    border-radius: 10px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.settings.primary};
    font-family: ${({ theme }) => theme.fonts.inter};
    background: ${({ theme }) => theme.settings.whiteColor};

    &::placeholder {
      color: rgba(10, 27, 57, 0.4);
      font-style: italic;
    }

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.settings.primary};
    }
  }

  button {
    height: 48px;
    padding: 0 24px;
    background: ${({ theme }) => theme.settings.primary};
    border: none;
    border-radius: 10px;
    color: white;
    font-size: 14px;
    font-weight: 600;
    font-family: ${({ theme }) => theme.fonts.inter};
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.9;
    }

    svg {
      font-size: 16px;
    }
  }
`;

export const AudienceChangedBanner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #f5f4f7;
  border-bottom: 1px solid #e8e6eb;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(36, 58, 184, 0.08);

  @media only screen and (max-width: 576px) {
    flex-direction: column;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
  }
`;

export const AudienceChangedText = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;

  svg {
    font-size: 18px;
    color: ${({ theme }) => theme.settings.primary};
    flex-shrink: 0;
  }

  span {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
    font-family: ${({ theme }) => theme.fonts.inter};
    line-height: 1.4;
  }
`;

export const RegenerateButton = styled.button`
  height: 36px;
  padding: 0 16px;
  background: #2E45DA;
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.inter};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    font-size: 14px;
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
    justify-content: center;
  }
`;

export const QuestionRegenerateBtn = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid rgba(10, 27, 57, 0.1);
  background: ${({ theme }) => theme.settings.whiteColor};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;

  svg {
    font-size: 14px;
    color: ${({ theme }) => theme.settings.primary};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.settings.primary};
    background: rgba(36, 58, 184, 0.05);

    svg {
      color: ${({ theme }) => theme.settings.primary};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DraggableQuestionCard = styled.div`
  position: relative;
  border: 1px solid ${props => (props.$isDragging ? '#260E52' : '#f0f0f0')};
  border-radius: 10px;
  background: ${props =>
    props.$isDragging ? 'rgba(36, 58, 184, 0.05)' : '#fff'};
  transition: all 0.2s ease;
  overflow: visible;

  &:hover {
    border-color: rgba(36, 58, 184, 0.3);
  }

  &:hover .insert-btn-wrapper {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const QuestionCardInner = styled.div`
  padding: 20px;
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: grab;
  user-select: none;
  flex-shrink: 0;
  color: ${({ theme }) => theme.settings.textColor};
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.settings.primary};
  }

  &:active {
    cursor: grabbing;
  }

  svg {
    font-size: 16px;
  }
`;

export const InsertButtonWrapper = styled.div`
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
`;

export const InsertAfterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: ${({ theme }) => theme.settings.cta_hover};
  border: none;
  border-radius: 20px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.inter};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(36, 58, 184, 0.25);

  svg {
    font-size: 12px;
  }

  &:hover {
    background: ${({ theme }) => theme.settings.cta_hover};
    transform: scale(1.05);
  }

  &:disabled {
    background: #b9bfd4;
    opacity: 0.7;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const InsertModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const InsertModalContent = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 16px;
  padding: 28px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
`;

export const InsertModalTitle = styled.h3`
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const InsertModalInput = styled.textarea`
  width: 100%;
  min-height: 100px;
  border: 1px solid rgba(10, 27, 57, 0.1);
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  background: ${({ theme }) => theme.settings.whiteColor};
  resize: vertical;

  &::placeholder {
    color: rgba(10, 27, 57, 0.4);
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.settings.primary};
  }
`;

export const InsertModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const InsertModalButton = styled.button`
  height: 44px;
  padding: 0 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.inter};
  cursor: pointer;
  transition: all 0.2s ease;

  &.primary {
    background: ${({ theme }) => theme.settings.primary};
    border: none;
    color: white;

    &:hover:not(:disabled) {
      opacity: 0.9;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &.secondary {
    background: transparent;
    border: 1px solid rgba(10, 27, 57, 0.1);
    color: ${({ theme }) => theme.settings.primary};

    &:hover {
      border-color: rgba(10, 27, 57, 0.2);
    }
  }
`;

export const SaveRegenerateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: auto;
  height: 36px;
  margin-top: 16px;
  margin-left: auto;
  padding: 0 16px;
  background: #2E45DA;
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.inter};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  svg {
    font-size: 14px;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AgeRangeWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 0;

  > * {
    flex: 1;
    min-width: 0;
    margin: 0;
  }
`;

export const SaveButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`;

export const LocationRadioGroup = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
  min-height: 42px;
  padding: 0 16px;
  border: 1px solid rgba(31, 36, 48, 0.1);
  border-radius: 10px;
  background: ${({ theme }) => theme.settings.whiteColor};
  margin: 0;
  max-width: 280px;

  .ant-radio-group {
    display: flex;
    align-items: center;
    gap: 24px;
    margin: 0;
  }

  .ant-radio-wrapper {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.inter};
    color: #2C2926;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    .ant-radio {
      top: 0;
    }

    .ant-radio-inner {
      width: 14px;
      height: 14px;
      border: 1px solid rgba(31, 36, 48, 0.2);
    }

    .ant-radio-checked .ant-radio-inner {
      border-color: #2E45DA !important;
      background-color: #2E45DA !important;
    }

    .ant-radio:hover .ant-radio-inner {
      border-color: #2E45DA !important;
    }

    .ant-radio-inner::after {
      background-color: white !important;
      width: 6px;
      height: 6px;
      margin-block-start: -3px;
      margin-inline-start: -3px;
    }
  }
`;

export const DisabledLabel = styled.div`
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0 16px;
  border: 1px solid rgba(10, 27, 57, 0.1);
  border-radius: 10px;
  background: ${({ theme }) => theme.settings.whiteColor};
  font-size: 14px;
  font-weight: 400;
  color: rgba(10, 27, 57, 0.4);
  font-family: ${({ theme }) => theme.fonts.inter};
  font-style: italic;
`;

/* Follow-up Question Styles */
export const FollowupContainer = styled.div`
  position: relative;
  margin-left: 20px;
  padding-left: 20px;
  margin-top: 12px;
`;

export const FollowupRow = styled.div`
  position: relative;
  display: flex;
  ${props => props.$hasMedia ? `
    flex-direction: column;
    align-items: stretch;
  ` : `
    align-items: center;
  `}
  gap: 10px;
  padding: 10px 12px;
  background: ${props => props.$isDragging ? 'rgba(46, 69, 218, 0.06)' : 'rgba(46, 69, 218, 0.02)'};
  border: 1px solid ${props => props.$isDragging ? '#2E45DA' : 'rgba(46, 69, 218, 0.15)'};
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s ease;

  /* Curved L-shaped connecting line */
  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: -8px;
    width: 16px;
    height: calc(50% + 8px);
    border-left: 1px solid rgba(46, 69, 218, 0.2);
    border-bottom: 1px solid rgba(46, 69, 218, 0.2);
    border-radius: 0 0 0 12px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: rgba(46, 69, 218, 0.3);
  }
`;

export const FollowupBadge = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(46, 69, 218, 0.15);
  border-radius: 6px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 500;
  font-size: 12px;
  color: #2E45DA;
  background: rgba(46, 69, 218, 0.03);
  flex-shrink: 0;
`;

export const FollowupText = styled.div`
  flex: 1;
  font-size: 14px;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  line-height: 1.4;
`;

export const FollowupActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const FollowupActionBtn = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(10, 27, 57, 0.1);
  background: ${({ theme }) => theme.settings.whiteColor};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;

  svg {
    font-size: 12px;
    color: ${({ theme }) => theme.settings.primary};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.settings.primary};
    background: rgba(36, 58, 184, 0.05);

    svg {
      color: ${({ theme }) => theme.settings.primary};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AddFollowupBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  margin-top: 8px;
  margin-left: 40px;
  background: transparent;
  border: 1px dashed rgba(46, 69, 218, 0.3);
  border-radius: 6px;
  color: #2E45DA;
  font-size: 13px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.inter};
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    font-size: 12px;
  }

  &:hover {
    background: rgba(46, 69, 218, 0.05);
    border-color: rgba(46, 69, 218, 0.5);
  }
`;

/* Media Upload & Preview Styles */
export const InsertModalLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  margin-bottom: 8px;
  margin-top: 16px;
`;

export const MediaUploadArea = styled.div`
  border: 1px dashed rgba(10, 27, 57, 0.2);
  border-radius: 10px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 120px;

  &:hover {
    border-color: ${({ theme }) => theme.settings.primary};
    background: rgba(46, 69, 218, 0.02);
  }

  .upload-icon {
    font-size: 28px;
    color: rgba(10, 27, 57, 0.3);
    margin-bottom: 8px;
  }

  .upload-text {
    font-size: 14px;
    color: rgba(10, 27, 57, 0.6);
    font-family: ${({ theme }) => theme.fonts.inter};
  }

  .upload-hint {
    font-size: 12px;
    color: rgba(10, 27, 57, 0.4);
    font-family: ${({ theme }) => theme.fonts.inter};
    margin-top: 4px;
  }
`;

export const MediaPreviewCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px;
  background: #f5f4f7;
  border: 1px solid rgba(209, 213, 220, 0.5);
  border-radius: 10px;
`;

export const MediaPreviewThumb = styled.div`
  width: 138px;
  height: 80px;
  min-width: 138px;
  border-radius: 8px;
  overflow: hidden;
  background: rgba(10, 27, 57, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .media-icon {
    font-size: 28px;
    color: rgba(10, 27, 57, 0.3);
  }
`;

export const MediaPreviewInfo = styled.div`
  flex: 1;
  min-width: 0;

  .media-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.settings.primary};
    font-family: ${({ theme }) => theme.fonts.inter};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .media-meta {
    font-size: 12px;
    color: rgba(10, 27, 57, 0.5);
    font-family: ${({ theme }) => theme.fonts.inter};
    margin-top: 4px;
  }
`;

export const MediaRemoveBtn = styled.button`
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(10, 27, 57, 0.4);

  &:hover {
    background: rgba(10, 27, 57, 0.06);
    color: ${({ theme }) => theme.settings.primary};
  }

  svg {
    font-size: 14px;
  }
`;

export const MediaBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.inter};
  background: ${({ $type }) =>
    $type === 'image' ? 'rgba(46, 69, 218, 0.08)' :
    $type === 'video' ? 'rgba(46, 69, 218, 0.08)' :
    'rgba(46, 69, 218, 0.08)'};
  color: #2E45DA;

  svg {
    font-size: 12px;
  }
`;

export const MediaDisplayWrapper = styled.div`
  margin: 12px 0;
  position: relative;

  .media-remove-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
    }
  }

  .media-container {
    width: 100%;
    height: 280px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &.media-image {
      background: #f5f4f7;
      cursor: pointer;
    }

    &.media-video {
      background: #101828;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      display: block;
    }

    video {
      width: 100%;
      max-height: 100%;
      display: block;
    }
  }
`;

export const PdfDisplayCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  background: #f5f4f7;
  border-radius: 10px;
  margin: 12px 0;
  min-height: 80px;

  .pdf-icon {
    width: 48px;
    height: 48px;
    min-width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 10px;
  }

  .pdf-info {
    flex: 1;
    min-width: 0;

    .pdf-title {
      font-size: 14px;
      font-weight: 600;
      color: #2C2926;
      line-height: 24px;
    }

    .pdf-subtitle {
      font-size: 12px;
      font-weight: 500;
      color: #2C2926;
      line-height: 24px;
    }
  }

  .pdf-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .pdf-view-btn {
    padding: 13px 16px;
    border: 1px solid rgba(46, 69, 218, 0.1);
    border-radius: 12px;
    background: #fff;
    font-size: 14px;
    font-weight: 600;
    color: #2E45DA;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    width: 83px;
    text-align: center;
    line-height: 16px;

    &:hover {
      border-color: rgba(46, 69, 218, 0.3);
    }
  }

  .pdf-remove-btn {
    padding: 13px 12px;
    border-radius: 12px;
    background: #fff;
    color: #2E45DA;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(46, 69, 218, 0.1);
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;

    &:hover {
      border-color: rgba(46, 69, 218, 0.3);
    }
  }
`;

export const FollowupDragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: grab;
  user-select: none;
  flex-shrink: 0;
  color: rgba(46, 69, 218, 0.4);
  transition: color 0.2s ease;

  &:hover {
    color: #2E45DA;
  }

  &:active {
    cursor: grabbing;
  }

  svg {
    font-size: 14px;
  }
`;

/* ---- Rule-based (conditional) follow-ups (2026-09-04) ----
   Deliberately a different accent (amber) from the blue used by unconditional
   follow-ups: the two behave differently during the call - a rule is asked only
   when its condition matches the answer - so they must not read as the same
   thing at a glance. Same L-connector geometry so the hierarchy still reads. */
export const RuleFollowupContainer = styled.div`
  position: relative;
  margin-left: 20px;
  padding-left: 20px;
  margin-top: 12px;
`;

export const RuleFollowupGroupLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #B45309;
  margin-bottom: 8px;

  .anticon {
    font-size: 12px;
  }
`;

export const RuleFollowupRow = styled.div`
  position: relative;
  display: flex;
  ${props => props.$hasMedia ? `
    flex-direction: column;
    align-items: stretch;
  ` : `
    align-items: flex-start;
  `}
  gap: 10px;
  padding: 10px 12px;
  background: ${props => props.$isDragging ? 'rgba(217, 119, 6, 0.08)' : 'rgba(217, 119, 6, 0.03)'};
  border: 1px solid ${props => props.$isDragging ? '#D97706' : 'rgba(217, 119, 6, 0.22)'};
  border-radius: 6px;
  margin-bottom: 8px;
  transition: all 0.2s ease;

  /* Curved L-shaped connecting line, matching FollowupRow */
  &::before {
    content: '';
    position: absolute;
    left: -20px;
    top: -8px;
    width: 16px;
    height: calc(50% + 8px);
    border-left: 1px solid rgba(217, 119, 6, 0.28);
    border-bottom: 1px solid rgba(217, 119, 6, 0.28);
    border-radius: 0 0 0 12px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: rgba(217, 119, 6, 0.45);
  }
`;

export const RuleFollowupBadge = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(217, 119, 6, 0.25);
  border-radius: 6px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 500;
  font-size: 12px;
  color: #B45309;
  background: rgba(217, 119, 6, 0.06);
  flex-shrink: 0;
`;

export const RuleFollowupBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/* The condition chip. Reads as "only asked when the answer is X" - the leading
   label is part of the chip so the condition is never mistaken for the question
   the participant hears. */
export const RuleConditionChip = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  align-self: flex-start;
  max-width: 100%;
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(217, 119, 6, 0.1);
  border: 1px solid rgba(217, 119, 6, 0.2);
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 11.5px;
  line-height: 1.35;

  .label {
    color: #B45309;
    font-weight: 600;
    white-space: nowrap;
  }

  .value {
    color: ${({ theme }) => theme.settings.primary};
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const RuleFollowupText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.settings.primary};
  font-family: ${({ theme }) => theme.fonts.inter};
  line-height: 1.4;
`;
